<template>
  <div>
    <section id="warning-signs" class="text-center siteSymptoms section">
      <div class="container">
        <h3>Shoulder Pain Often Gets Worse Without Timely Treatment</h3>
        <div class="row">
          <div class="mx-auto col-12 col-md-8">
            <p class="text-left text-sm-center">In severe cases, shoulder pain can cause difficulties in your day-to -day tasks like putting on your clothes. Individuals who experience the following signs are advised to seek treatment quickly.</p>
          </div>
        </div>
        <div class="row list-symptoms d-flex justify-content-center">
          <div class="col-6 col-md-4 col-lg-3 col-xl-2" v-for="(symptoms, i) in symptoms" :key="i">
            <div class="symptom">
              <div><img :src="symptoms.image" class="inline-block img-fluid rounded-circle" :alt="symptoms.name"></div>
              <h4 v-html="symptoms.name">{{ symptoms.name }}</h4>
            </div>
          </div>
        </div>
        <div id="pre-sport-screening" class="row">
          <div class="mx-auto col-12 col-xl-9 add-space">
            <p class="text-left text-sm-center">Shoulder pain treatments can go a long way in helping you retain your mobility. Dr Sean Ng can help you overcome shoulder pain with conscientious care and modern minimally invasive treatments. Non-surgical shoulder treatments are also available.</p>
          </div>
        </div>
        <a href="#enquire-now" class="site-btn">Enquire Now</a>
      </div>
    </section>
  </div>
</template>

<style scoped>
  .list-symptoms {
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .symptom {
    margin-bottom: 20px;
  }
  .symptom img {
    margin-bottom: 15px;
    border: 4px solid #c9d2d5;
  }
  .symptom h4 {
    font-size: 16px;
    font-weight: 600;
    color: #0a1432;
    line-height: 24px;
  }
  .add-space img {
    margin: 30px 0;
  }
  @media (min-width: 992px) {
    .symptom img {
      border: 8px solid #c9d2d5;
    }
    .add-space {
      margin-top: 20px;
    }
  }
  @media (min-width: 1200px) {
    .symptom img {
      border: 4px solid #c9d2d5;
    }
  }
</style>

<script>
  export default {
    data () {
      return {
        symptoms: [
          {
            image: '/images/img-symptoms-01.jpg',
            name: 'Unable To Raise Shoulder',
          },
          {
            image: '/images/img-symptoms-02.jpg',
            name: 'Swelling In Shoulder',
          },
          {
            image: '/images/img-symptoms-03.jpg',
            name: 'Numbness In Arm',
          },
          {
            image: '/images/img-symptoms-04.jpg',
            name: 'Sharp Pain During Movements',
          }
        ]
      }
    }
  }
</script>